import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { SERVICES } from '../../data/constants';
import { IconBrain, IconDatabase, IconCloud, IconCpu, IconServer, IconGlobe } from '../ui/Icons';
import './Services.css';

const SERVICE_ICONS = [
  <IconBrain    size={20} />,
  <IconDatabase size={20} />,
  <IconCloud    size={20} />,
  <IconCpu      size={20} />,
  <IconServer   size={20} />,
  <IconGlobe    size={20} />,
];

export const Services: React.FC = () => {
  const { ref, inView } = useIntersectionObserver({ threshold: 0.04, triggerOnce: true });

  return (
    <section id="services" className="services section section--dark" ref={ref}>
      <div className="container">
        <div className="section__header">
          <span className="section__subtitle">CAPABILITIES</span>
          <h2 className="section__title">What I Build</h2>
          <p className="section__description">
            End-to-end delivery across GenAI, data platforms, and cloud infrastructure -
            from architecture design to production deployment.
          </p>
        </div>

        <div className="services__list">
          {SERVICES.map((svc, i) => (
            <motion.div
              key={i}
              className={`svc__item ${i === 0 ? 'svc__item--featured' : ''}`}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            >
              {/* Left: number + icon */}
              <div className="svc__left">
                <span className="svc__num">0{i + 1}</span>
                <div className="svc__icon">{SERVICE_ICONS[i]}</div>
              </div>

              {/* Center: title + desc + tools */}
              <div className="svc__body">
                <h3 className="svc__title">{svc.title}</h3>
                <p className="svc__desc">{svc.description}</p>
                {svc.tools && svc.tools.length > 0 && (
                  <div className="svc__tools">
                    {svc.tools.map((t, ti) => (
                      <span key={ti} className="svc__tool">{t}</span>
                    ))}
                  </div>
                )}
              </div>

              {/* Right: arrow */}
              <div className="svc__arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
